/**
 * Hook principal para egresos - Usa Firebase en producción, mock en desarrollo
 */

import { useMemo } from 'react';
import { useEgresosFirebase } from './useEgresosFirebase';
import { useEgresosMock } from './useEgresosMock';
import { useAuth } from '../../auth/hooks/useAuth';
import { LoggerService } from '../../../shared/services/logger.service';

export const useEgresos = () => {
  const { user } = useAuth();
  
  // Detectar si Firebase está configurado y el usuario autenticado
  const shouldUseFirebase = useMemo(() => {
    const hasApiKey = !!import.meta.env.VITE_FIREBASE_API_KEY;
    const hasProjectId = !!import.meta.env.VITE_FIREBASE_PROJECT_ID;
    const hasUser = !!user?.uid;
    return hasApiKey && hasProjectId && hasUser;
  }, [user?.uid]);

  // Llamar hooks de forma condicional pero consistente
  const firebaseData = useEgresosFirebase();
  const mockData = useEgresosMock();

  // Decidir qué datos usar basado en la configuración
  if (shouldUseFirebase) {
    LoggerService.info('Using Firebase egresos (production)', 'useEgresos', { userId: user?.uid });
    return firebaseData;
  } else {
    LoggerService.info('Using mock egresos (development or no auth)', 'useEgresos');
    return mockData;
  }
};